import {
  faAddressBook,
  faArchive,
  faBalanceScale,
  faBook,
  faCamera,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

export const ServicesSection = () => {
  return (
    <Container fluid className="services-section">
      <Container>
        <Row>
          <Col data-aos="fade-right">
            <h2>My Services</h2>
            <div className="underline"></div>
            <p data-aos="fade-left" className="eye-catching-text">
              Ut vel officiis mollitia. Incidunt repudiandae quaerat aperiam
              temporibus nihil quia. Quo nostrum aut minus sint est.
            </p>
          </Col>
        </Row>
        <Row>
          <Col sm="12" md="12" lg="4">
            <a href="/">
              <div className="widget-container" data-aos="fade-right">
                <FontAwesomeIcon
                  className="icon"
                  icon={faAddressBook}
                  size="2x"
                />
                <h3 className="title">Header One</h3>
                <p>
                  Ullam dicta dolorem quas. Soluta consequatur sed non
                  reiciendis. Quia libero voluptatem eveniet.
                </p>
              </div>
            </a>
          </Col>
          <Col sm="12" md="12" lg="4">
            <a href="/">
              <div className="widget-container" data-aos="fade-in">
                <FontAwesomeIcon
                  className="icon"
                  icon={faBalanceScale}
                  size="2x"
                />
                <h3 className="title">Header Two</h3>
                <p>
                  Ullam dicta dolorem quas. Soluta consequatur sed non
                  reiciendis. Quia libero voluptatem eveniet.
                </p>
              </div>
            </a>
          </Col>
          <Col sm="12" md="12" lg="4">
            <a href="/">
              <div className="widget-container" data-aos="fade-left">
                <FontAwesomeIcon className="icon" icon={faClock} size="2x" />
                <h3 className="title">Header Three</h3>
                <p>
                  Ullam dicta dolorem quas. Soluta consequatur sed non
                  reiciendis. Quia libero voluptatem eveniet.
                </p>
              </div>
            </a>
          </Col>
        </Row>
        <Row>
          <Col sm="12" md="12" lg="4">
            <a href="/">
              <div className="widget-container" data-aos="fade-right">
                <FontAwesomeIcon className="icon" icon={faArchive} size="2x" />
                <h3 className="title">Header Four</h3>
                <p>
                  Ullam dicta dolorem quas. Soluta consequatur sed non
                  reiciendis. Quia libero voluptatem eveniet.
                </p>
              </div>
            </a>
          </Col>
          <Col sm="12" md="12" lg="4">
            <a href="/">
              <div className="widget-container" data-aos="fade-in">
                <FontAwesomeIcon className="icon" icon={faCamera} size="2x" />
                <h3 className="title">Header Five</h3>
                <p>
                  Ullam dicta dolorem quas. Soluta consequatur sed non
                  reiciendis. Quia libero voluptatem eveniet.
                </p>
              </div>
            </a>
          </Col>
          <Col sm="12" md="12" lg="4">
            <a href="/">
              <div className="widget-container" data-aos="fade-left">
                <FontAwesomeIcon className="icon" icon={faBook} size="2x" />
                <h3 className="title">Header Six</h3>
                <p>
                  Ullam dicta dolorem quas. Soluta consequatur sed non
                  reiciendis. Quia libero voluptatem eveniet.
                </p>
              </div>
            </a>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
